import {
  resolveTariffDisabledReason,
  resolveTariffTargetIds,
  TariffTargetDelivery,
} from 'src/components/dispatch/tariffCalculationAvailability';

export type MapTariffInput = {
  deliveries: TariffTargetDelivery[];
  /** Container が導出した取得系の理由。null なら取得は正常 */
  deliveryDataDisabledReason: string | null;
  hasPendingRemoval: boolean;
  isResetting: boolean;
  /** 自動配車 controller の実行中（Task 10: 配車結果が書き換わっている最中は運賃計算も止める） */
  isBusy: boolean;
  /** 運賃計算そのものの実行中。押し直せると同じ計算が二重に走る */
  isCalculatingTariff?: boolean;
};

/**
 * /map の運賃計算の可否。
 *
 * Why not Presenter に条件式を直書き: /map の Presenter は query を持たないため
 * 取得系の判定材料が Container 側にしかなく、条件が 2 ファイルに割れる。
 * 判定をここへ寄せると、取得系（文字列 1 本）と画面状態を 1 箇所で突き合わせられる。
 */
export function resolveMapTariffAvailability(input: MapTariffInput): {
  targetIds: number[];
  disabledReason: string | null;
} {
  const targetIds = resolveTariffTargetIds(input.deliveries);
  if (input.deliveryDataDisabledReason) {
    return { targetIds, disabledReason: input.deliveryDataDisabledReason };
  }
  return {
    targetIds,
    disabledReason: resolveTariffDisabledReason({
      isError: false,
      isFetching: false,
      // isResetting を先に見る。resolveBusyGuardReason と同じ優先順位
      // （isBusy は resetting を内包するため、逆にすると「未割当に戻す」中に嘘をつく）
      hasUnsettledChange: input.hasPendingRemoval || input.isResetting || input.isBusy
        || Boolean(input.isCalculatingTariff),
      unsettledReason: (input.isResetting && '配車を変更中です')
        || (input.isBusy && '自動配車の実行中です')
        || (input.isCalculatingTariff && '運賃計算の実行中です')
        || '未確定の変更があります',
      targetCount: targetIds.length,
    }),
  };
}

export type DeliveryQueryState = {
  isError: boolean;
  isFetching: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
};

/** 取得系だけを見た理由。null なら取得は正常 */
export function resolveDeliveryDataDisabledReason(q: DeliveryQueryState): string | null {
  if (q.isError) return '配車データを取得できませんでした';
  if (q.isFetching || q.hasNextPage || q.isFetchingNextPage) return '配車データを読み込み中です';
  return null;
}
